import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import PerformanceMonitor from './components/PerformanceMonitor';

// Import page components
import HomePage from './pages/HomePage';
import SouthingtonPage from './pages/SouthingtonPage';
import RecipesPage from './pages/RecipesPage';
import WinePage from './pages/WinePage';
import FutbolPage from './pages/FutbolPage';
import JeepPage from './pages/JeepPage';
import GenesPage from './pages/GenesPage';
import FamilyTreePage from './pages/FamilyTreePage';
import CalendarPage from './pages/CalendarPage';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        {/* Performance monitoring in development */}
        {process.env.NODE_ENV === 'development' && <PerformanceMonitor />}
        
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/southington" element={<SouthingtonPage />} />
            <Route path="/recipes" element={<RecipesPage />} />
            <Route path="/wine" element={<WinePage />} />
            <Route path="/futbol" element={<FutbolPage />} />
            <Route path="/jeep" element={<JeepPage />} />
            <Route path="/genes" element={<GenesPage />} />
            <Route path="/family-tree" element={<FamilyTreePage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            {/* Fallback route for 404 */}
            <Route path="*" element={<HomePage />} />
          </Routes>
        </Layout>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
